<template lang="pug">
  .restaurants(v-if="content")
    .page__wr
      PageConstruction(v-if="content.pageConstruction")
      template(v-else)
        Bread(v-if="content.bread", :bread="content.bread")
        .restaurants__title(v-if="h1") {{h1}}
        .restaurants__items(v-if="content.items")
          a.restaurants__item(v-for="item in content.items", :key="item.id", :href="item.link", target="_blank")
            .restaurants__item-top
              .restaurants__item-img-wr
                img.restaurants__item-img(v-if="item.img", :src="item.img")
            .restaurants__item-bottom
              .restaurants__item-text(v-if="item.text") {{item.text}}
              .restaurants__item-btn(v-if="item.btn") {{item.btn}}
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/restaurants/restaurants.styl';

  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import Bread from '@/components/common/bread/bread.vue';
  import PageConstruction from '@/components/common/pageConstruction/pageConstruction.vue';

  export default {
    name: 'Restaurants',

    mixins: [AjaxHelpersVue],

    data() {
      return {
        content: null,
        more: false
      }
    },

    components: {
      Bread,
      PageConstruction
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadRestaurantsPage', params => {
        this.request(params.url);
      });
    },

    methods: {
      request(url) {
        this.req('RestaurantsPage:getRestaurantsPage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;
          }
        }, 'restaurants');
      },
    }

  }
</script>
